// src/components/orders/wizard/CustomerStep.js - FIX AUTO-SELEZIONE
import React, { useState } from 'react';
import {
  User, Search, ArrowRight, X, Building, Hash, MapPin, Mail, FileText, UserPlus
} from 'lucide-react';
import { useCustomers } from '../../../hooks/useApi';
import DestinationSelector from '../DestinationSelector';

const CustomerStep = ({
  data,
  updateData,
  validateStep,
  validations,
  nextStep,
  invalidateStepsAfter,
  updateCustomer
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Usa uno state locale per il termine di ricerca invece di dipendere da data.customer
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const { customers } = useCustomers(customerSearchTerm);

  // RIMOZIONE DELL'USEEFFECT PROBLEMATICO!
  // L'useEffect che marcava automaticamente i clienti dalla bozza come "selezionati"
  // causava il problema di auto-selezione durante la digitazione.

  // Ora gestiamo la selezione solo attraverso interazioni esplicite dell'utente:
  // 1. Click su suggerimento dalla lista
  // 2. Click su "Crea Cliente e Continua"

  // Gestione selezione cliente esistente
  const handleCustomerSelect = (selectedCustomer) => {
    const customerData = {
      ...selectedCustomer,
      isNewCustomer: false,
      isSelected: true // Flag per indicare che è stato selezionato volontariamente
    };

    // Se il cliente ha destinazioni extra, prova a selezionare quella predefinita
    let selectedDestination = null;
    if (selectedCustomer.destinations && selectedCustomer.destinations.length > 0) {
      // Cerca la destinazione predefinita
      const defaultDestinationIndex = selectedCustomer.destinations.findIndex(dest => dest.isDefault);
      if (defaultDestinationIndex !== -1) {
        selectedDestination = { ...selectedCustomer.destinations[defaultDestinationIndex], index: defaultDestinationIndex };
      }
    }

    updateCustomer(customerData);
    updateData({
      customer: customerData,
      selectedDestination: selectedDestination
    });
    setShowSuggestions(false);
    setCustomerSearchTerm(''); // Reset del termine di ricerca
    setTimeout(() => {
      const updatedData = {
        ...data,
        customer: customerData,
        selectedDestination: selectedDestination
      };
      validateStep(1, validations.customer, updatedData);
    }, 100);
  };

  // Reset completo
  const resetCustomerSelection = () => {
    const emptyCustomer = {
      companyName: '',
      legalAddress: '',
      city: '',
      zipCode: '',
      vatNumber: '',
      sdiCode: '',
      email: '',
      isNewCustomer: false,
      isSelected: false
    };
    updateCustomer(emptyCustomer);
    updateData({
      customer: emptyCustomer,
      selectedDestination: null
    });
    setShowSuggestions(false);
    setCustomerSearchTerm(''); // Reset del termine di ricerca
    invalidateStepsAfter(1);
  };

  // Gestione modifica dati cliente - SENZA AUTO-SELEZIONE
  const handleCustomerDataChange = (field, value) => {
    const updatedCustomer = {
      ...data.customer,
      [field]: value,
      isSelected: false // Assicuriamoci che non sia mai auto-selezionato
    };
    updateCustomer(updatedCustomer);
    updateData({ customer: updatedCustomer });

    // Mostra suggerimenti quando digita la ragione sociale
    if (field === 'companyName') {
      setCustomerSearchTerm(value);
      setShowSuggestions(value.length > 2);
    }
  };

  // Crea nuovo cliente con i dati inseriti - SELEZIONE ESPLICITA
  const handleCreateNewCustomer = () => {
    const newCustomer = {
      ...data.customer,
      isNewCustomer: true,
      isSelected: true // Marca come selezionato SOLO quando l'utente clicca il pulsante
    };
    updateCustomer(newCustomer);
    updateData({ customer: newCustomer });
    setShowSuggestions(false);

    // Valida e procedi al passo successivo
    setTimeout(() => {
      const currentData = { ...data, customer: newCustomer };
      const isValid = validations.customer(currentData);
      if (isValid) {
        validateStep(1, validations.customer, currentData);
        nextStep();
      }
    }, 100);
  };

  // Avanzamento diretto per cliente già selezionato
  const handleNextStep = () => {
    // Controllo se il cliente ha destinazioni extra e se ne è stata selezionata una
    const hasMultipleDestinations = data.customer?.destinations && data.customer.destinations.length > 0;
    const hasSelectedDestination = data.selectedDestination;

    if (hasMultipleDestinations && !hasSelectedDestination) {
      console.warn('⚠️ Cliente con destinazioni multiple - seleziona una destinazione');
      return;
    }

    // Passa i dati correnti esplicitamente alla validazione
    const currentData = { ...data };
    const isValid = validations.customer(currentData);

    if (isValid) {
      // Valida e abilita lo step successivo passando i dati correnti
      validateStep(1, validations.customer, currentData);
      nextStep();
    } else {
      console.warn('⚠️ Validazione cliente fallita - controlla i dati');
    }
  };

  const hasSearchResults = customers && customers.length > 0 && data.customer?.companyName?.length > 2;
  const isCustomerSelected = data.customer?.isSelected === true; // Controllo esplicito
  const canCreateNew = data.customer?.companyName && data.customer.companyName.trim().length > 2;

  // Controllo se serve selezionare una destinazione
  const hasMultipleDestinations = data.customer?.destinations && data.customer.destinations.length > 0;
  const needsDestinationSelection = hasMultipleDestinations && !data.selectedDestination;
  const canProceed = isCustomerSelected && !needsDestinationSelection;

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="text-center mb-6 lg:mb-8">
        <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-full flex items-center justify-center mx-auto mb-4" style={{backgroundColor: '#fcfbd6'}}>
          <User className="w-8 h-8 lg:w-10 lg:h-10" style={{color: '#c48f75'}} />
        </div>
        <h2 className="text-xl lg:text-2xl font-bold text-gray-900 mb-2">
          Informazioni Cliente
        </h2>
        <p className="text-gray-600 text-sm lg:text-base">
          Inserisci i dati del cliente per questo ordine
        </p>
      </div>

      <div className="max-w-2xl mx-auto">

        {/* CLIENTE CONFERMATO */}
        {isCustomerSelected && (
          <div className="space-y-6">
            <div className="border-2 rounded-xl p-6" style={{backgroundColor: '#fcfbd6', borderColor: '#c48f75'}}>
              <div className="flex items-start justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{backgroundColor: '#c48f75'}}>
                    <Building className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-lg">
                      {data.customer.companyName}
                    </h3>
                    <div className="text-sm text-gray-700 space-y-1">
                      {data.customer.city && <p>📍 {data.customer.city}{data.customer.zipCode && ` - ${data.customer.zipCode}`}</p>}
                      {data.customer.vatNumber && <p>🏢 P.IVA: {data.customer.vatNumber}</p>}
                      {data.customer.email && <p>✉️ {data.customer.email}</p>}
                    </div>
                  </div>
                </div>
                <button
                  onClick={resetCustomerSelection}
                  className="text-gray-500 hover:text-red-600 transition-colors"
                  title="Modifica cliente"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>

            {/* Selettore destinazione per clienti con più indirizzi */}
            <DestinationSelector
              customer={data.customer}
              selectedDestination={data.selectedDestination}
              onDestinationChange={(destination) => {
                updateData({ selectedDestination: destination });
              }}
            />
          </div>
        )}

        {/* FORM RICERCA/CREAZIONE CLIENTE */}
        {!isCustomerSelected && (
          <div className="space-y-6">
            {/* Campo ricerca */}
            <div className="relative">
              <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
                <Search className="w-4 h-4 mr-2" />
                Ragione Sociale *
              </label>
              <input
                type="text"
                value={data.customer?.companyName || ''}
                onChange={(e) => handleCustomerDataChange('companyName', e.target.value)}
                onFocus={() => setShowSuggestions(data.customer?.companyName?.length > 2)}
                onBlur={() => {
                  // Ritarda la chiusura per permettere i click sui suggerimenti
                  setTimeout(() => setShowSuggestions(false), 200);
                }}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 transition-colors login-input"
                placeholder="Inizia a digitare per cercare o creare..."
              />

              {/* Lista suggerimenti */}
              {showSuggestions && hasSearchResults && (
                <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-y-auto">
                  {customers.map((customer) => (
                    <button
                      key={customer.id}
                      onClick={() => handleCustomerSelect(customer)}
                      className="w-full text-left px-4 py-3 hover:transition-colors border-b border-gray-100 last:border-b-0"
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#fcfbd6';
                        e.target.style.color = '#1f2937';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '';
                        e.target.style.color = '';
                      }}
                    >
                      <div className="font-medium text-gray-900">{customer.companyName}</div>
                      <div className="text-sm text-gray-600">
                        {customer.city && `${customer.city}`}
                        {customer.zipCode && ` - ${customer.zipCode}`}
                        {(customer.city || customer.zip) && customer.vatNumber && ' • '}
                        {customer.vatNumber && `P.IVA: ${customer.vatNumber}`}
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Campi aggiuntivi cliente */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* P.IVA */}
              <div>
                <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
                  <Hash className="w-4 h-4 mr-2" />
                  Partita IVA
                </label>
                <input
                  type="text"
                  value={data.customer?.vatNumber || ''}
                  onChange={(e) => handleCustomerDataChange('vatNumber', e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 transition-colors login-input"
                  placeholder="IT12345678901"
                />
              </div>

              {/* Codice SDI */}
              <div>
                <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
                  <FileText className="w-4 h-4 mr-2" />
                  Codice SDI
                </label>
                <input
                  type="text"
                  value={data.customer?.sdiCode || ''}
                  onChange={(e) => handleCustomerDataChange('sdiCode', e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 transition-colors login-input"
                  placeholder="ABC1234"
                />
              </div>

              {/* Indirizzo */}
              <div>
                <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
                  <Building className="w-4 h-4 mr-2" />
                  Indirizzo
                </label>
                <input
                  type="text"
                  value={data.customer?.legalAddress || ''}
                  onChange={(e) => handleCustomerDataChange('legalAddress', e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 transition-colors login-input"
                  placeholder="Via Roma, 123"
                />
              </div>

              {/* Città */}
              <div>
                <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
                  <MapPin className="w-4 h-4 mr-2" />
                  Città
                </label>
                <input
                  type="text"
                  value={data.customer?.city || ''}
                  onChange={(e) => handleCustomerDataChange('city', e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 transition-colors login-input"
                  placeholder="Milano"
                />
              </div>

              {/* CAP */}
              <div>
                <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
                  <Hash className="w-4 h-4 mr-2" />
                  CAP
                </label>
                <input
                  type="text"
                  value={data.customer?.zipCode || ''}
                  onChange={(e) => handleCustomerDataChange('zipCode', e.target.value.replace(/\D/g, ''))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 transition-colors login-input"
                  placeholder="20100"
                  maxLength="5"
                />
              </div>

              {/* Email */}
              <div className="md:col-span-2">
                <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
                  <Mail className="w-4 h-4 mr-2" />
                  Email
                </label>
                <input
                  type="email"
                  value={data.customer?.email || ''}
                  onChange={(e) => handleCustomerDataChange('email', e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 transition-colors login-input"
                  placeholder="info@cliente.it"
                />
              </div>
            </div>

            {/* Info stato cliente */}
            {canCreateNew && !hasSearchResults && (
              <div className="border rounded-xl p-4" style={{backgroundColor: '#fcfbd6', borderColor: '#c48f75'}}>
                <div className="flex items-center space-x-3">
                  <UserPlus className="w-5 h-5" style={{color: '#c48f75'}} />
                  <div>
                    <p className="font-medium text-gray-900">Nuovo Cliente</p>
                    <p className="text-sm text-gray-700">
                      Questo cliente verrà aggiunto all'archivio quando confermi l'ordine
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* NAVIGAZIONE */}
        <div className="flex justify-between items-center mt-8 pt-6 border-t border-gray-200">
          <div></div> {/* Spacer per step 1 */}

          {/* Pulsante diverso se è cliente esistente o nuovo */}
          {isCustomerSelected ? (
            <button
              onClick={handleNextStep}
              disabled={!canProceed}
              className={`flex items-center space-x-2 px-4 sm:px-6 lg:px-8 py-3 rounded-xl font-medium shadow-lg hover:shadow-xl transition-all ${canProceed
                  ? 'text-white'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
              style={canProceed ? {backgroundColor: '#c48f75'} : {}}
              onMouseEnter={(e) => canProceed && (e.target.style.backgroundColor = '#4c4849')}
              onMouseLeave={(e) => canProceed && (e.target.style.backgroundColor = '#c48f75')}
            >
              <span>
                {needsDestinationSelection ? 'Seleziona Destinazione' : 'Continua'}
              </span>
              <ArrowRight className="w-5 h-5" />
            </button>
          ) : (
            <button
              onClick={canCreateNew ? handleCreateNewCustomer : undefined}
              disabled={!canCreateNew}
              className={`flex items-center space-x-2 px-4 sm:px-6 py-3 rounded-xl font-medium transition-all ${canCreateNew
                  ? 'text-white shadow-lg hover:shadow-xl'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
              style={canCreateNew ? {backgroundColor: '#c48f75'} : {}}
              onMouseEnter={(e) => canCreateNew && (e.target.style.backgroundColor = '#4c4849')}
              onMouseLeave={(e) => canCreateNew && (e.target.style.backgroundColor = '#c48f75')}
            >
              {canCreateNew ? (
                <>
                  <UserPlus className="w-5 h-5" />
                  <span>Crea Cliente e Continua</span>
                  <ArrowRight className="w-5 h-5" />
                </>
              ) : (
                <>
                  <span>Inserisci Ragione Sociale</span>
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerStep;